import { uiConfig } from '../../../../config/ui.config';

export const unsubscribeFromEmailNotifications = async (reportId: string, email: string): Promise<void> => {
  const url = `${uiConfig.getApiBaseAddress('1.2')}/reports/savedreports/unsubscribe`;
  const response = await fetch(url, {
    method: 'PATCH',
    body: JSON.stringify({ reportId, email }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Failed to unsubscribe: ${errorText}`);
  }
};
